// @flow
import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';

/**
 * <Image /> component.
 */
class Image extends PureComponent<*, *> {
  /**
   * Props implementation.
   * @param {object} props - component props
   */
  constructor(props: Object) {
    super(props);
    this.state = {
      imageErrored: false
    };
  }

  /* eslint-disable camelcase */
  /**
   * UNSAFE_componentWillReceiveProps implementation.
   * @param {object} nextProps object
   */
  UNSAFE_componentWillReceiveProps(nextProps: Object) {
    if (this.props.src !== nextProps.src) {
      this.setState({ imageErrored: false });
    }
  }

  /**
   *    Default Props implementation.
   */
  static defaultProps: Object = {
    onErrorEvent: 'replace'
  };

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} className - class name for image.
   * @prop {string} src - image source.
   * @prop {string} title - title attribute.
   * @prop {string} alt - alt attribute for logo.
   */
  static propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    src: PropTypes.string.isRequired,
    title: PropTypes.string, // Title and alt is not coming through from Autotrader
    alt: PropTypes.string,
    onErrorEvent: PropTypes.string
  };

  handleError: () => void = () => {
    this.setState({ imageErrored: true });
  };

  /**
   * Renders <Image /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render(): Element<*> | null {
    const { className, src, onErrorEvent, ...otherProps } = this.props;
    let imageSrc = src;
    if (this.state.imageErrored) {
      if (onErrorEvent === 'delete') {
        return null;
      }
      imageSrc = `${process.env.PUBLIC_URL || ''}/images/fallback.png`;
    }

    return (
      <img
        className={classNames(className)}
        src={imageSrc}
        {...otherProps}
        onError={this.handleError}
      />
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/Common/Image/index.js